import styled from 'styled-components';

export const InfoContainer = styled.div`
  & > div {
    margin-bottom: 14px;
  }
`;

export const FormWrapper = styled.div`
  .ant-form-item {
    width: 288px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  & > div {
    margin-right: 50px;
  }
`;

export const DeleteContainer = styled.div`
  display: flex;
  & > div:last-child {
    margin-left: 16px;
    align-self: flex-start;
    margin-top: 33px;
    cursor: pointer;
  }
`;
